$(document).ready(function () {
  // $(document).on('click', '#cdk_main_option-1 .subscription-variaent-detail-wrapper', function () {
  //   var CurFinalValue = "";
  //   var currentOptionName = $(this).attr("data-value");
  //   console.log("currentOptionName::" + currentOptionName);
  //   $('.variant-option-2 select option').each(function () {
  //        var allValues = $(this).val();
  //        console.log('allValues::'+allValues);
  //        CurFinalValue += currentOptionName + " / " + allValues;
  //        console.log('CurFinalValue::'+CurFinalValue);
  //      });

  // })
  $(document).on("click", ".subscription-variaent-detail-wrapper", function () {
    $(this).siblings().removeClass("active");
    $(this).addClass("active");
    var OptionName = $(this).attr("data-value");
    $(this)
      .parents(".swatches-block")
      .find(".cdk-select")
      .val(OptionName)
      .change();
    //  console.log("OptionName::" + OptionName);
  });
  $(document).on("change", ".swatches-block select.cdk-select", function () {
    var FinalValue = "";
    // var thisParentId = $(this).parents(".product-card-wrapper .quick-view-wrapper").attr("data-id");
    // console.log('thisParentId::'+ thisParentId);
    $(".swatches-block").each(function () {
      var selectVal = $(this).find("select.cdk-select").val();
      //  console.log('selectVal::'+selectVal);
      FinalValue += selectVal + " / ";
      //  console.log('FinalValue::'+FinalValue);
    });
    var newstr = FinalValue.substring(0, FinalValue.length - 3);
    var optionName_Selector = $(
      '.choosing-wines-bg .product-card__variant-box select option[check-data-sku="' +
        newstr +
        '"]'
    );
    var optionName_val = optionName_Selector.val();
    //  console.log('optionName_val::'+optionName_val);
    $(".choosing-wines-bg .product-card__variant-box select")
      .val(optionName_val)
      .change();
  });

  $(document).on(
    "change",
    ".choosing-wines-bg .product-card__variant-box select",
    function () {
      var thisMainVal = $(this).val();
      var ThisProdAvail = $(this)
        .find('option[value="' + thisMainVal + '"]')
        .attr("data-varaint-availability");
      var ThisProdNP = $(this)
        .find('option[value="' + thisMainVal + '"]')
        .attr("data-price");
      var ThisProIMG = $(this)
        .find('option[value="' + thisMainVal + '"]')
        .attr("data-image");
      var ThisBtnText = $(this)
        .find('option[value="' + thisMainVal + '"]')
        .attr("data-btn-text");
      var ThisSellingId = $(this)
        .find('option[value="' + thisMainVal + '"]')
        .attr("data-selling-plan-id");
      $(
        ".mobile-subscription-bg .mobile-subscription-products .mobilesubscription-product-images img"
      ).attr("src", ThisProIMG);
      $(this)
        .parents(".product-card__form")
        .find(".selling_plan__id")
        .val(ThisSellingId);
      if (ThisProdAvail == "true") {
        $(".subscription_atc").attr("data-btn", "addToCart");
        $(".subscription_atc").text(ThisBtnText);
      } else {
        $(".subscription_atc").text("Sold Out");
        $(".subscription_atc").attr("data-btn", "soldout");
      }
    }
  );

  // function for changing the image above the choice of colour options...
  // so that they update depending on the quantity of bottles selected.
  // - and display the correct calorie saving on mobile
  const bottlesQuantitySelector = document.querySelectorAll(
    ".variant-option-1 .subscription-variaent-detail-wrapper.swatches-option"
  );
  const bottlesColourSelector = document.querySelectorAll(
    ".variant-option-2 .subscription-variaent-detail-wrapper.swatches-option"
  );
  const calorieMessages = document.querySelectorAll(".mobile-calorie-saving");

  if (bottlesQuantitySelector.length > 0) {
    bottlesQuantitySelector.forEach((el, i) => {
      el.addEventListener("click", (e) => {
        const bottleCount = e.currentTarget.dataset.value;
        // meassaging
        calorieMessages.forEach((el) => {
          el.classList.remove("active");
          if (el.dataset.size === bottleCount) {
            el.classList.add("active");
          }
        });

        //
        //
        bottlesColourSelector.forEach((el) => {
          const thisOptionValue = el.dataset.value;

          const productImage = el.querySelector("img");

          const productVariant = window.pluroSubscriptionProductVariants.find(
            (variant) => {
              return variant.title === `${bottleCount} / ${thisOptionValue}`;
            }
          );
          const variantImage = productVariant?.featured_image.src;

          productImage.src = variantImage;
        });
      });
    });
  }
});
